import React, { useEffect, useRef, useCallback, useMemo, useState } from 'react';

import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntLocalization from '../utils/AntLocalization';

import { AntGlobal, AntSession } from '../utils/AntContext';

export default function (props) {

    const appGlobal = AntGlobal();

    var hasDetails = props.errors instanceof Array && props.errors.length > 0;
    var errorDetails = (hasDetails ? props.errors.join('\n') : '').split('\n');
    var errorId = props.id;
    var errorText = props.text;

    return (
        <React.Fragment>
            <div className="ant-error-page">
                <img
                    src={appGlobal.appAssets ? appGlobal.appAssets.images.errorIcon1 : ''}
                    style={{ width: '260px !important' }}
                />
                <span className={props.fontType === 'small' ? 'ant-error-page-text-small' : 'ant-error-page-text'}>
                    {AntLocalization.translateText(errorText)}
                </span>
            </div>
        </React.Fragment>
    );
}
